import { useEffect, useState } from 'react';

interface ElementSize {
  width: number | undefined;
  height: number | undefined;
}

export const useWindowSize = (): ElementSize => {
  const [windowSize, setWindowSize] = useState<ElementSize>({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};
